import {computed, defineComponent} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapToolsBar',
    props: {
        tagName: {
            type: String,
            default: 'div'
        },
        modVertical: Boolean
    },
    setup(props) {
        const classes = computed(() => {
            return [
                'kl-ol-map-tools-bar',
                {
                    'kl-ol-map-tools-bar--vertical': props.modVertical
                }
            ]
        })
        return {
            classes
        }
    }
})
